var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { LoadStatus, PlayStatus } from '../../../learnware/LearnwareEnums';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
export class PlayerIntents {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get allIntents() {
        return this.parent.intents;
    }
    intentsByPlayStatus(playStatus) {
        return this.allIntents.filter(intent => intent.playStatus === playStatus);
    }
    intentsByLoadStatus(loadStatus) {
        return this.allIntents.filter(intent => intent.loadStatus === loadStatus);
    }
    get loadingIntents() {
        return [...this.pendingIntents, ...this.startedIntents].filter(intent => intent.loadStatus === LoadStatus.Loading);
    }
    get pendingIntents() {
        return this.intentsByPlayStatus(PlayStatus.Pending);
    }
    get startedIntents() {
        return this.intentsByPlayStatus(PlayStatus.Go);
    }
    get playingIntents() {
        return this.intentsByPlayStatus(PlayStatus.Playing);
    }
    get completedIntents() {
        return this.intentsByPlayStatus(PlayStatus.Ended);
    }
    get playingAndStartedIntents() {
        return this.playingIntents.concat(this.startedIntents);
    }
    get playingStartedAndPendingIntents() {
        return this.playingIntents.concat(this.startedIntents).concat(this.pendingIntents);
    }
}
__decorate([
    sortedSet
], PlayerIntents.prototype, "pendingIntents", null);
